<template>
  <div class="container mt-3 text-center" style="height: 87%">
    <br>
    <h1> Echec de la connexion </h1>
    <br>

    <h5>Bonjour {{ $route.query.gender | pronom }} {{ $route.query.given_name }} {{ $route.query.family_name }} </h5>
    <div>
      <label>Nous n'avons pas réussi à vous identifier...</label> <br> <br>
      <label> 
        Si vous êtes un(e) patient(e) du {{ hospitalName }} vous pouvez envoyer un mail à <b> {{ hospitalMail }} </b> <br>
        en renseignant votre nom, prénom, date de naissance et votre Identifiant Permanent Patient afin d'exercer vos droits.
      </label>
    </div>
    <br>
    <div>
      <small>
        Vous pouvez retrouver votre Identifiant Permanent Patient :
        <ul class="mt-0">
          <li>sur vos comptes rendus d'examens</li>
          <li>sur vos comptes rendus d'hospitalisation</li>
          <li>sur vos documents de facturation : relevés, récapitulatifs et factures</li>
        </ul>
      </small>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  data() {
    return {
      hospitalName: process.env.VUE_APP_HOSPITAL_NAME,
      hospitalMail: process.env.VUE_APP_HOSPITAL_MAIL
    };
  }
};
</script>
